import { render, staticRenderFns } from "./sendMes.vue?vue&type=template&id=155c3e6e"
import script from "./sendMes.vue?vue&type=script&lang=ts"
export * from "./sendMes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports